webpackJsonp([35783957827783],{

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { style: { backgroundColor: "black" } },
	    _react2.default.createElement(
	      "section",
	      { "class": "TestDrive" },
	      _react2.default.createElement(
	        "div",
	        { className: "emergencybanner" },
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "Code Fellows has ceased operations."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { backgroundColor: "black", color: "white", textAlign: "left", padding: "40px 40px 40px 40px", maxWidth: "800px", margin: "0 auto" } },
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            "A Legacy of Innovation and Transformation in Tech Education"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Code Fellows has ceased operations."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "As we close our doors after 11 incredible years and more than $80 million in all-time positive economic impact for our graduates, we want to thank everyone who has been part of our mission and celebrate the incredible journey we\u2019ve completed together. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We extend our deepest gratitude to our students, employees, investors, partners, and supporters. Thank you for your belief in, and dedication to Code Fellows' mission, and for making tech a more vibrant, innovative, and inclusive landscape!"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To our employees: you\u2019ve gone above and beyond, often working long hours and facing countless challenges to ensure that our students received the best education experience possible. Our impact would be nothing without your unwavering commitment, tireless work, love for learning, care for our students, and relentless pursuit of excellence. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Code Fellows was more than just a coding school. We created a transformative community where people from all walks of life could come together, embrace their differences, and work to create a more diverse and inclusive future in the tech industry. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "\"Achieving greatness at the scale we\u2019ve reached at Code Fellows requires exceptional people working together tirelessly toward a shared mission, under shared values. It has been a privilege and an honor to be part of this journey and to witness the incredible outcomes of our mission-driven work. From the beginning, our mission at Code Fellows was to provide transformative, career-focused education that opened doors for people from all backgrounds. Our goal was to make tech inclusive and accessible, and I\u2019m incredibly proud of how we\u2019ve accomplished that. We have disrupted the education industry in the best ways possible.\" \u2014 Jeff Malek, CEO"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "We invested heavily in creating a learning environment where every student felt welcome, safe, and heard. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "\u201COur first course included people from all kinds of backgrounds\u2014yoga instructors, bartenders, IT pros, folks from the gaming industry. Our theory was that a few intensive weeks of classes could have these individuals tech-job-ready. We knew we had hit something big when two students received software development job offers on the last day of class\u2026 before they had technically even graduated!\u201D \u2014 Brook Riggio, Co-Founder & VP of Education"
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Code Fellows was built on the belief that the future of tech should be shaped by the beautiful breadth of diversity in our world. We have created innovative new pathways for learners, and were the first in the Pacific Northwest to offer accelerated tech career onramps. People and partnerships have been at the heart of it all. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "\"We have always believed that in order to accomplish our goals of ensuring every student has an opportunity to succeed we need to forge strong partnerships with like-minded individuals, companies, and organizations that share the same values. Partnering together allows us to leverage our collective strengths and ensure we create lasting change. Giving students a firm foundation and growth can dramatically improve their education and access to careers previously out of reach, and our partners are a big part of helping us do that!\" \u2013 Mitchell Robertson, Co-Founder & SVP of Growth"
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Our Impact"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "ul",
	            { style: { textAlign: "left" } },
	            _react2.default.createElement(
	              "li",
	              null,
	              "3,338 graduates, including 2,185 from HQ and 1,153 from partner schools."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "93% in-field employment rate."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "> $80M per year in increased economic benefit due to in-field employment of Code Fellows Grads, who increased their annual salaries by $44K on average."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "$4.86M in scholarships provided, with a focus on empowering individuals from underserved and underrepresented backgrounds. Partnered with organizations like Apprenti and Mentorworks, and provided financial aid options through the GI Bill, VET TEC, Climb Credit, BFET, OKC Rescue, our Scholarship Fund and corporate sponsorships."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Ranked as the number one bootcamp for landing a job at a major tech company, ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.switchup.org/blog/coding-bootcamps-vs-college-for-prestigious-tech-jobs", target: "_blank" },
	                " rivaling"
	              ),
	              " even Stanford University\u2019s prestigious computer science department."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "2,716 hours of cutting-edge coding and cybersecurity curriculum created in collaboration with top tech companies, including training in AI, career coaching and DEI. "
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Created a powerful, white-label school management tech platform, implementing extensive automation in course management and student support, seamlessly integrating with best-of-breed platforms like Salesforce, Canvas, Zoom, and Slack. Our web presence has had nearly zero downtime. "
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Launched our bias-free hiring portal, hired.codefellows.org."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Implemented a white-label Powered By Code Fellows licensing program, enabling the use of our curriculum and know-how for partners."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Recipient of the ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.codefellows.org/blog/code-fellows-wins-wtia-dei-award/", target: "_blank" },
	                "WTIA DEI Award."
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Employed 626 incredible Code Fellows staff members."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Final Thoughts"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "As we close our doors, we\u2019re confident that our impact will continue to resonate throughout the tech industry. We\u2019ve touched thousands of lives and have helped to launch thousands of new careers. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The Code Fellows spirit lives on through our graduates and former staff. They carry forward our values of continuous learning, adaptability, and inclusivity. The ripple effects of our work will be felt for years to come. We\u2019ve set a high bar for future initiatives in this space, and we\u2019re immensely proud of what we\u2019ve accomplished."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "As we reflect on our journey, we celebrate not just what we achieved, but the potential we unlocked in the individuals who will continue to shape the future of technology. The Code Fellows legacy is now in the hands of our alumni. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To our alumni: we are working to make all of our courses available to you for self-study, and you can expect to see further information about this via email in the coming weeks. Your resumes will continue to be available online for the next 30 days, please create a copy of your own as needed. Thank you again for trusting us with your futures in technology; we can't wait to see the new heights you'll reach! "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Those looking for cybersecurity career training can reach out to our partner, Infosec Institute. They are a leading cybersecurity education company with over 20 years of training experience, and they offer a ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.infosecinstitute.com/skills/cybersecurity-online-programs/beginners/", target: "_blank" },
	            "Cybersecurity Foundations Immersive Boot Camp"
	          ),
	          " that can prepare you for an entry-level role in as little as 26 weeks. Learn more about your cybersecurity career training options, or contact ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:info@infosecinstitute.com", target: "_blank" },
	            "info@infosecinstitute.com"
	          ),
	          " to speak to someone directly. "
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If you are a Veteran or military spouse interested in starting a career in ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://launchyourcareer.codeplatoon.org/become_a_software_engineer", target: "_blank" },
	            "Software Engineering"
	          ),
	          " or DevOps and Cloud Engineering, you can contact our friends at ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.codeplatoon.org/", target: "_blank" },
	            "Code Platoon"
	          ),
	          ". They are a nonprofit coding bootcamp providing high-quality tech education designed for Veterans and military spouses, with programs that accept VA Education benefits. Learn more at ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.codeplatoon.org/", target: "_blank" },
	            "codeplatoon.org"
	          ),
	          " or contact ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:info@codeplatoon.org", target: "_blank" },
	            "info@codeplatoon.org"
	          ),
	          " to talk with a member of the recruitment team."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Thank you to everyone who has been a part of Code Fellows. Our journey of education is ending, but the impact we\u2019ve made together will live on."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "                       "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "StudentProfiles" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "profiles" },
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/qjy3jg1udcmq/21fjLxG3SYSYM2OOQaUEEI/123268c24d4fa0159f58b5149bd17ee3/caleb-wells.png", alt: "Caleb Wells" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"After Code Fellows, I\u2019m ready to deal with a large gamut of industry practices. We were introduced to source control (git flow) and Agile methodology, and experienced working in a development team to pair program.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Caleb Wells"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Software Development Engineer, Alaska Airlines"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/qjy3jg1udcmq/5dedhlSJHaeO8sIWYWWKuQ/231f6351820c96b3bd37c13e10b2f2c3/rae-helsel.png", alt: "Rae Helsel" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"The teachers are amazing, and the curriculum is on point and well-organized, but the best part of the program for me was the sense of community. That\u2019s everything.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Rae Helsel"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "CEO | Developer, R\u0100NA"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/k428n7s2pxlu/4eNsB8T7a0yiMwyW6a0qIu/adef6fa6c8a250719cf94d7eb940a4b4/katlyn.jpeg", alt: "Kaylyn Yuh" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"Code Fellows enables you to challenge your learning every day, and motivates you to be an impactful individual and a strong team player.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Kaylyn Yuh"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Software Developer, Bevy"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/k428n7s2pxlu/3iMknAabmUccEMoCsCayMc/42dcd303df167db34d0d2517bda85a37/lee.jpeg", alt: "Lee Broxson" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"The program\u2014especially the project weeks\u2014is focused on a pseudo-production situation. As a result, I got a good understanding of what a real-world dev job is like, and that is appealing to employers.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Lee Broxson"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Senior Software Engineer, Avalara"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "Subheader" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 badges" },
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.coursereport.com/schools/code-fellows" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/5JIajsMTOU0NQ0cHdgiTSy/ae7648c376fe4e489abd804ac44e3c0e/Best_Coding_Bootcamps_Badge_2023_New__2_.png", alt: "Course Report" })
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.switchup.org/bootcamps/code-fellows" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/yKQMr2YJhegfMq1Kgeks3/5f2e43e7849cfca4538d6e29d433258f/su-best-coding-2022-6years.png", alt: "Switchup" })
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.coursereport.com/schools/code-fellows" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/5Orp1b7wOQqcyGwpck1PM3/9b87ad9382e02720326654ac0eb3b3d6/Best_Online_Bootcamps_Badge_2022_New__1_.png" })
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://careerkarma.com/schools/code-fellows/" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/1NyyNLfTMZeYAnpdrnN0Kz/499636e9a0671463b5b9f2d70c0bf5fe/Best__cyber_security_bootcamp.png", alt: "Career Karma" })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 1957:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1957);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	var _landing = __webpack_require__(297);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // SYLES
	//import './_index.scss'
	
	
	// LIBS
	
	
	// HELPERS
	var prefixLink = function prefixLink(url) {
	  return url;
	};
	
	// COMPONENTS
	
	// INTERFACE
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'wrapper' },
	      _react2.default.createElement(_metaData2.default, { data: {
	          slug: '',
	          title: 'Premier Tech Academy | Discover a Rewarding New Career | Code Fellows',
	          description: 'Code Fellows is the Pacific Northwest’s premier technical skills training academy, delivering high-quality live instruction both online and in person to people from all backgrounds.'
	        } }),
	      _react2.default.createElement(_landing2.default, null)
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	module.exports = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5956faba1ede1b2d8f29.js